import React from "react";
import ContactForm from "@/components/ContactForm";
import { useLanguage } from "@/context/LanguageContext";
import { PHONE_DISPLAY, PHONE_LINK, WHATSAPP_LINK } from "@/lib/translations";
import { Phone, MessageCircle, Clock } from "lucide-react";

export default function ContactPage() {
  const { t } = useLanguage();

  return (
    <div data-testid="contact-page">
      <section className="py-24">
        <div className="container-pad grid gap-14 lg:grid-cols-[1.2fr_1fr]">
          <div>
            <div className="overline">{t.contact.overline}</div>
            <h1 className="mt-4 font-serif text-5xl sm:text-6xl leading-[1] text-brand-primary">
              {t.contact.title}
            </h1>
            <p className="mt-6 text-lg text-brand-text/75 leading-relaxed max-w-lg">
              {t.contact.subtitle}
            </p>

            <div className="mt-10 space-y-5 max-w-md">
              <a
                href={PHONE_LINK}
                data-testid="contact-phone"
                className="flex items-center gap-4 rounded-xl bg-brand-surface border border-brand-line p-5 hover:-translate-y-0.5 hover:shadow-md transition-all"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-subtle text-brand-primary">
                  <Phone size={20} />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-brand-muteText">
                    {t.contact.info.phone_label}
                  </div>
                  <div className="font-serif text-xl text-brand-primary">{PHONE_DISPLAY}</div>
                </div>
              </a>

              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp"
                className="flex items-center gap-4 rounded-xl bg-brand-surface border border-brand-line p-5 hover:-translate-y-0.5 hover:shadow-md transition-all"
              >
                <div
                  className="flex h-12 w-12 items-center justify-center rounded-full text-white"
                  style={{ backgroundColor: "#25D366" }}
                >
                  <MessageCircle size={20} />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-brand-muteText">
                    {t.contact.info.whatsapp_label}
                  </div>
                  <div className="font-serif text-xl text-brand-primary">
                    {t.contact.info.whatsapp_value}
                  </div>
                </div>
              </a>

              <div className="flex items-center gap-4 rounded-xl bg-brand-surface border border-brand-line p-5">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-subtle text-brand-primary">
                  <Clock size={20} />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-brand-muteText">
                    {t.contact.info.hours_label}
                  </div>
                  <div className="font-serif text-xl text-brand-primary">
                    {t.contact.info.hours_value}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
}
